import { fg } from '@atlaskit/platform-feature-flags';

import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForConfluenceEndUserRequestExperiment(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		hasPaymentDetailsEntered,
		isInCollection,
		canUpgrade,
		userId,
		changeOfferingToStandardExperienceUrl,
		transactionAccountId,
		entitlementId,
	} = context;

	return Boolean(
		!isInCollection &&
		// Eligibility criteria
		product === 'confluence' &&
		edition === 'free' &&
		hasPaymentDetailsEntered === true &&
		canUpgrade === false &&
		// Verify that the data needed to send the request is available
		Boolean(userId) &&
		Boolean(changeOfferingToStandardExperienceUrl) &&
		Boolean(transactionAccountId) &&
		Boolean(entitlementId) &&
		fg('connie_end_user_request_kill_switch'),
	);
}
